import { useEffect } from 'react'
import { useAuth } from '../auth/hooks/useAuth'
import { useToast } from '../../lib/toast'
import { ensureConnected, subscribe } from './userEventsSocket'

export default function UserEventsBridge() {
  const { session, refreshProfile } = useAuth()
  const { toast } = useToast()

  useEffect(() => {
    ensureConnected(session?.access_token)
  }, [session?.access_token])

  useEffect(() => {
    const unsub = subscribe('balance_updated', (data) => {
      const creditedAmount = Number(data?.amount || 0)
      const topupAmount = Number(data?.topup_amount || 0)
      const bonusAmount = Number(data?.bonus_amount || 0)
      const bonusPercentRaw = Number(data?.bonus_percent || 0)
      const bonusPercent = bonusPercentRaw > 0
        ? bonusPercentRaw
        : (topupAmount > 0 && bonusAmount > 0 ? Math.floor((bonusAmount * 100) / topupAmount) : 0)
      const bonusReason = typeof data?.bonus_reason === 'string' ? data.bonus_reason.trim() : ''

      if (creditedAmount > 0 && topupAmount > 0) {
        const breakdown = bonusAmount > 0
          ? `Nạp ${topupAmount.toLocaleString('vi-VN')}đ + thưởng ${bonusAmount.toLocaleString('vi-VN')}đ (${bonusPercent}%) = ${creditedAmount.toLocaleString('vi-VN')}đ vào tài khoản.`
          : `Nạp ${topupAmount.toLocaleString('vi-VN')}đ vào tài khoản.`

        toast({
          variant: 'success',
          title: 'Nạp tiền thành công! 🎉',
          message: bonusReason ? `${breakdown} ${bonusReason}` : breakdown,
          durationMs: 6000,
        })
      } else if (creditedAmount > 0) {
        toast({
          variant: 'success',
          title: 'Cập nhật số dư',
          message: 'Số dư của bạn vừa được cập nhật.',
          durationMs: 4000,
        })
      }

      refreshProfile()
    })

    return () => {
      unsub()
    }
  }, [toast, refreshProfile])

  return null
}
